import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=0ec6a9ff&scoped=true&"
import script from "./Stickers.vue?vue&type=script&lang=js&"
export * from "./Stickers.vue?vue&type=script&lang=js&"
import style0 from "./Stickers.vue?vue&type=style&index=0&id=0ec6a9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6a9ff",
  null
  
)

export default component.exports